import MagicLinkRouter from '.';

export default {
  base: '',
  items: [{ path: '/magic-link', component: MagicLinkRouter }]
};
